var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sutl } from '../../../sutl';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
function interfaceIsEqual(a, b) {
    return a.unit === b.unit && a.module === b.module && a.port === b.port;
}
function findVlanByInterface(vlans, iface) {
    return vlans.find(vlan => vlan.number > 10 &&
        vlan.interfaces.find(vif => interfaceIsEqual(vif, iface)) !== undefined);
}
function findVlanByNumber(vlans, vlanNumber) {
    return vlans.find(vlan => vlan.number === vlanNumber);
}
function getReceiverCode(iface) {
    return `rx_port_${iface.unit}_${iface.port}`;
}
function getReceiverName(iface) {
    return `Port ${iface.unit}/${iface.port}`;
}
function getTransmitterCode(vlan) {
    return `tx_vlan_${vlan.number}`;
}
function getTransmitterName(vlan) {
    return vlan.name;
}
function parseReceiverCode(code) {
    const [, , unit, port] = code.split('_');
    return { port: parseInt(port, 10), unit: parseInt(unit, 10) };
}
function parseTransmitterCode(code, vlans) {
    const [, , vlanStr] = code.split('_');
    return findVlanByNumber(vlans, parseInt(vlanStr, 10));
}
class CiscoSg300Api {
    constructor(syntax, interfacesColumn, socket) {
        this.syntax = syntax;
        this.interfacesColumn = interfacesColumn;
        this.socket = socket;
        this.vlanColumn = 0;
        this.nameColumn = 1;
    }
    requestFeedback(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.sendAsync('terminal datadump', tags);
        });
    }
    setRoute(receiver, vlan, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.socket.sendAsync(`enable`, tags);
            yield this.socket.sendAsync(`config`, tags);
            yield this.socket.sendAsync(`int gi${receiver.port}`, tags);
            yield this.socket.sendAsync(`sw gen al vl rem 11-410`, tags);
            yield this.socket.sendAsync(`sw gen al vl ad ${vlan.number} unt`, tags);
            yield this.socket.send(`end`, /^.*(?:\(config-if\))#\s*end/, tags);
        });
    }
}
class CiscoSg300V13Api extends CiscoSg300Api {
    constructor(socket) {
        super('ciscoSg300V1.3', 2, socket);
    }
}
class CiscoSg300V14Api extends CiscoSg300Api {
    constructor(socket) {
        super('ciscoSg300V1.4', 3, socket);
    }
}
class CiscoSg500Api {
    constructor(syntax, interfacesColumn, socket) {
        this.syntax = syntax;
        this.interfacesColumn = interfacesColumn;
        this.socket = socket;
        this.vlanColumn = 0;
        this.nameColumn = 1;
    }
    requestFeedback(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.sendAsync('terminal datadump', tags);
        });
    }
    setRoute(receiver, vlan, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const { module = 1, port, unit } = receiver;
            yield this.socket.sendAsync(`enable`, tags);
            yield this.socket.sendAsync(`config`, tags);
            yield this.socket.sendAsync(`int gi${unit}/${module}/${port}`, tags);
            yield this.socket.sendAsync(`sw gen al vl rem 11-399`, tags);
            yield this.socket.sendAsync(`sw gen al vl ad ${vlan.number} unt`, tags);
            yield this.socket.send(`end`, /^.*(?:\(config-if\))#\s*end/, tags);
        });
    }
    testIsTransmitter(iface, tags) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send(`show int sw gi${iface.unit}/${(_a = iface.module) !== null && _a !== void 0 ? _a : 1}/${iface.port}`, /^\s*Ingress\s+UnTagged\s+VLAN\s*(\s*NATIVE\s*)\s*:?\s*(\d+)/, tags);
            return parseInt(match[1], 10) > 10;
        });
    }
}
class CiscoSg500V13Api extends CiscoSg500Api {
    constructor(socket) {
        super('ciscoSg500V1.3', 2, socket);
    }
}
class CiscoSg500V14Api extends CiscoSg500Api {
    constructor(socket) {
        super('ciscoSg500V1.4', 3, socket);
    }
}
class LuxulApi {
    constructor(syntax, socket) {
        this.syntax = syntax;
        this.socket = socket;
        this.vlanColumn = 0;
        this.nameColumn = 1;
        this.interfacesColumn = 2;
        this.interfacesRegExp = /Gi\s*(\S+)/i;
    }
    requestFeedback(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.sendAsync('terminal length 0', tags);
        });
    }
    setRoute(receiver, vlan, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.socket.sendAsync(`con t`, tags);
            yield this.socket.sendAsync(`int gi ${receiver.unit}/${receiver.port}`, tags);
            yield this.socket.sendAsync(`sw hy al vl 10,${vlan.number}`, tags);
            yield this.socket.send(`end`, /^(?:\(config-if\))*# end/, tags);
        });
    }
}
class LuxulStandaloneApi extends LuxulApi {
    constructor(socket) {
        super('luxulStandalone', socket);
    }
}
class LuxulStackableApi extends LuxulApi {
    constructor(socket) {
        super('luxulStackable', socket);
    }
    testIsTransmitter(iface, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send(`show int gi ${iface.unit}/${iface.port} sw`, /^\s*Hybrid\s+Native\s+Mode\s+VLAN\s*:?\s*(\d+)/i, tags);
            return parseInt(match[1], 10) > 10;
        });
    }
}
export class JustAddPower {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        this.configurationQueried = false;
        this.detectedFirmwareVersion = 'Unknown';
        this.isQueryingVlans = false;
        this.receivers = [];
        this.vlans = [];
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                unterminatedRegExp: /(.+):/,
                next: /User\s*name/i,
            },
            {
                errorCode: 'verifyFailed',
                send: (cred) => {
                    var _a;
                    return (_a = cred.username) !== null && _a !== void 0 ? _a : 'admin';
                },
                unterminatedRegExp: /(.+):/,
                next: /Password/i,
                fail: /Wrong username or password/i,
            },
            {
                errorCode: 'authFailed',
                send: (cred) => {
                    var _a;
                    return (_a = cred.password) !== null && _a !== void 0 ? _a : 'admin';
                },
                unterminatedRegExp: /(.+)/,
                timeoutMs: 5000,
                next: /.*#/,
                fail: /Wrong username or password|User\s*name/i,
            },
        ];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.computeDetected(this.vlans, this.receivers);
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.detectedFirmwareVersion;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const receiver = parseReceiverCode(key);
                const transmitterVlan = findVlanByInterface(this.vlans, receiver);
                if (transmitterVlan === undefined) {
                    throw new Error(`no route for receiver ${JSON.stringify(receiver)}`);
                }
                return getTransmitterCode(transmitterVlan);
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const receiver = parseReceiverCode(key);
                const vlan = parseTransmitterCode(value, this.vlans);
                if (vlan === undefined) {
                    this.log.error(`no vlan for transmitter ${value}`);
                    return this.state.videoMatrixRoutes.values[key];
                }
                if (this.api === undefined) {
                    this.log.error(`api undefined`);
                }
                else {
                    yield this.api.setRoute(receiver, vlan, tags);
                }
                return value;
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 5000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (this.isQueryingVlans) {
                        this.log.info(`poll: vlan query in progress, skipping this poll interval`);
                        return;
                    }
                    const prevVlans = this.vlans;
                    // Don't use standard 'poll' tag for querying VLANs since the query consists of
                    // multiple commands and we don't want to partially remove some of them when a
                    // set operation occurs.
                    this.vlans = yield this.queryVlans(['poll.keep']);
                    this.updateVideoMatrixRoutes(this.vlans, this.receivers);
                    // If the Just Add Power devices in VLAN 10 changed or the number of transmitter
                    // VLANS changed, then we need to redetect and recompute the transmitters and
                    // receivers, so go back to the configuring phase.
                    const prevVlan10 = findVlanByNumber(this.vlans, 10);
                    const vlan10 = findVlanByNumber(this.vlans, 10);
                    const prevTransmitterVlans = prevVlans
                        .filter(vlan => vlan.number > 10)
                        .map(vlan => vlan.number)
                        .sort();
                    const transmitterVlans = this.vlans
                        .filter(vlan => vlan.number > 10)
                        .map(vlan => vlan.number)
                        .sort();
                    if (!Sutl.objEquals(prevVlan10, vlan10) ||
                        !Sutl.objEquals(prevTransmitterVlans, transmitterVlans)) {
                        this.framework.changePhase('configuring');
                    }
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.configurationQueried) {
                const tags = ['configure'];
                this.vlans = yield this.queryVlans(tags);
                [, this.receivers] = yield this.classifyInterfaces(this.vlans, tags);
                this.configurationQueried = true;
            }
        });
    }
    onInitialize(credentials) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            this.configurationQueried = false;
            const result = yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
            if (result === 'connected') {
                let luxulVersionMatch;
                try {
                    luxulVersionMatch = yield this.socket.send('show version brief', /Version\s*:\s*(\S+)|Wrong number of parameters/i, ['initialize']);
                }
                catch (_e) { }
                if (luxulVersionMatch === null || luxulVersionMatch === void 0 ? void 0 : luxulVersionMatch[1]) {
                    this.detectedFirmwareVersion = luxulVersionMatch[1];
                    let isStackable = false;
                    try {
                        const productMatch = yield this.socket.send('show version', /^Product\s*:\s*(.+)/i, ['initialize'], { sendTimeoutMs: 4000 });
                        isStackable = (_b = (_a = productMatch[1]) === null || _a === void 0 ? void 0 : _a.includes('AMS-4424P')) !== null && _b !== void 0 ? _b : false;
                    }
                    catch (_f) { }
                    this.api = isStackable
                        ? new LuxulStackableApi(this.socket)
                        : new LuxulStandaloneApi(this.socket);
                }
                else {
                    const ciscoVersionMatch = yield this.socket.send('show version', /\s*version\s*:?\s+(\S+)|1\s+(\S+)\s+(\S+)\s+(\S+)/i, ['initialize']);
                    if (ciscoVersionMatch[1]) {
                        this.detectedFirmwareVersion = ciscoVersionMatch[1];
                        this.api = this.detectedFirmwareVersion.startsWith('1.3')
                            ? new CiscoSg300V13Api(this.socket)
                            : new CiscoSg300V14Api(this.socket);
                    }
                    else {
                        this.detectedFirmwareVersion = ciscoVersionMatch[2];
                        this.api = this.detectedFirmwareVersion.startsWith('1.3')
                            ? new CiscoSg500V13Api(this.socket)
                            : new CiscoSg500V14Api(this.socket);
                    }
                }
                this.log.info(`detected API syntax: ${this.api.syntax}`);
                yield ((_d = (_c = this.api).requestFeedback) === null || _d === void 0 ? void 0 : _d.call(_c, ['initialize']));
                // Wait for all the output from the previous commands(s) to be received.
                yield this.socket.send('show', /^% Incomplete command/i);
            }
            return result;
        });
    }
    // other class methods
    classifyInterfaces(vlans, tags) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const receivers = [];
            const transmitters = [];
            const vlan10 = findVlanByNumber(vlans, 10); // VLAN 10 contains all Just Add Power devices
            if ((_a = this.api) === null || _a === void 0 ? void 0 : _a.testIsTransmitter) {
                // In multi-unit systems, we have to test each interface individually.
                if (vlan10 === undefined) {
                    this.log.error(`missing VLAN 10`);
                    return [[], []];
                }
                for (const iface of vlan10.interfaces) {
                    const isTransmitter = yield this.api.testIsTransmitter(iface, tags);
                    if (isTransmitter) {
                        transmitters.push(iface);
                    }
                    else {
                        receivers.push(iface);
                    }
                }
            }
            else {
                // In single-unit systems, the first interface listed in a VLAN is the transmitter.
                for (const vlan of vlans) {
                    if (vlan.number <= 10)
                        continue; // transmitter VLANs are 11+
                    const interfaces = [...vlan.interfaces];
                    transmitters.push(interfaces[0]);
                    interfaces.splice(0, 1);
                    receivers.push(...interfaces);
                }
            }
            return [transmitters, receivers];
        });
    }
    computeDetected(vlans, receivers) {
        const videoInputs = [];
        const videoOutputs = [];
        for (const iface of this.receivers) {
            videoOutputs.push({
                code: getReceiverCode(iface),
                name: getReceiverName(iface),
            });
        }
        for (const vlan of this.vlans) {
            if (vlan.number > 10) {
                videoInputs.push({
                    code: getTransmitterCode(vlan),
                    external: true,
                    name: getTransmitterName(vlan),
                });
            }
        }
        return { videoInputs, videoOutputs };
    }
    // Convert strings of the following format into an array of interfaces.
    //
    // Luxul AMS-1208P/AMS-2616P/XMS-2624P format: 1,21-26
    // Luxul AMS-4424P format: 3/1,16-24
    // Cisco format: gi2/1/3,gi2/1/10-14,gi5/1/10,
    parseInterfaces(str) {
        const interfaces = [];
        const parts = str.split(',');
        let unit = 1;
        let module;
        for (const part of parts) {
            const match = /\D*(.+)/.exec(part);
            if (!match)
                continue;
            const components = match[1].split('/');
            const n = components.length;
            const ports = this.parseRange(components[n - 1]);
            if (n > 1)
                unit = parseInt(components[0], 10);
            if (n > 2)
                module = parseInt(components[1], 10);
            for (const port of ports) {
                const iface = {
                    unit,
                    port,
                };
                if (module !== undefined)
                    iface.module = module;
                interfaces.push(iface);
            }
        }
        return interfaces;
    }
    // Convert port ranges: "5" -> [5] and "9-12" -> [9, 10, 11, 12]
    parseRange(str) {
        const range = str.split('-');
        if (range.length === 1) {
            return [parseInt(range[0], 10)];
        }
        else {
            const start = parseInt(range[0], 10);
            const end = parseInt(range[1], 10);
            const ports = [];
            for (let port = start; port <= end; port++) {
                ports.push(port);
            }
            return ports;
        }
    }
    // Port/vlan numbering:
    //
    // Transmitters start in port 2 and are connected in port order until out of transmitters.
    // Then, receivers continue after the transmitters. This is true of each unit in the stack.
    //
    // VLAN 1: local area network connection/control
    // VLAN 10: all Just Add Power devices will be listed here
    // VLAN 11: first transmitter
    // VLAN 12-N: subsequent transmitters
    //
    // Typical show vlan response on the Luxul AMS-4424P switch:
    //
    // # show vlan
    // VLAN  Name                              Interfaces
    // ----  --------------------------------  ----------
    // 1     default                           Gi 1/1
    //                                         Gi 2/1
    //                                         Gi 3/1,16-24
    // 10    JAP_22x38_123.....                Gi 1/2-24
    //                                         Gi 2/2-24
    //                                         Gi 3/2-15
    // 11    TX_1_gi1/2                        Gi 1/2
    // 12    TX_2_gi1/3                        Gi 1/3
    // 13    TX_3_gi1/4                        Gi 1/4
    // 14    TX_4_gi1/5                        Gi 1/5
    // 15    TX_5_gi1/6                        Gi 1/6
    //                                         Gi 2/10-24
    //                                         Gi 3/6-15
    // 16    TX_6_gi1/7                        Gi 1/7
    // 17    TX_7_gi1/8                        Gi 1/8
    // 18    TX_8_gi1/9                        Gi 1/9
    // 19    TX_9_gi1/10                       Gi 1/10
    // 20    TX_10_gi1/11                      Gi 1/11
    // 21    TX_11_gi2/2                       Gi 2/2
    // 22    TX_12_gi2/3                       Gi 2/3
    // 23    TX_13_gi2/4                       Gi 2/4
    // 24    TX_14_gi2/5                       Gi 2/5
    // 25    TX_15_gi2/6                       Gi 2/6
    // 26    TX_16_gi2/7                       Gi 2/7
    // 27    TX_17_gi2/8                       Gi 2/8
    // 28    TX_18_gi2/9                       Gi 2/9
    // 29    TX_19_gi3/2                       Gi 3/2
    // 30    TX_20_gi3/3                       Gi 3/3
    // 31    TX_21_gi3/4                       Gi 3/4
    // 32    TX_22_gi3/5                       Gi 3/5
    //
    // In the example above, the transmitters are on VLANs 11-32, for a total of 22 transmitters.
    // They are on ports 1/2-11,2/2-9,3/2-5.
    //
    // From VLAN 10, we see that all the Just Add Power devices are 1/2-24, 2/2-24, 3/2-15. We
    // remove the transmitters from this collection, resulting in 38 transmitters on ports
    // 1/12-24, 2/10-24, 3/6-15.
    //
    // On the Luxul AMS-1208P/AMS-2616P/XMS-2624P, the first port listed is the transmitter.
    // However, this is not always true for the Luxul AMS-4424P. To determine which port in a VLAN
    // is the transmitter, we use the "show interface GigabitEthernet switchport" command. Below
    // are example outputs from this command for a transmitter and then a receiver.
    //
    // # show int gi 1/2 sw
    // Name: GigabitEthernet 1/2
    // Administrative mode: hybrid
    // Access Mode VLAN: 11
    // Trunk Native Mode VLAN: 1
    // Administrative Native VLAN tagging: disabled
    // Allowed VLANs: 1-4095
    // Hybrid port configuration
    // -------------------------
    // Port Type: Unaware
    // Acceptable Frame Type: All
    // Ingress filter: Disabled
    // Egress tagging: None
    // Hybrid Native Mode VLAN: 11
    // Hybrid VLANs Enabled: 10,11
    //
    //
    // # show int gi 1/12 sw
    // Name: GigabitEthernet 1/12
    // Administrative mode: hybrid
    // Access Mode VLAN: 1
    // Trunk Native Mode VLAN: 1
    // Administrative Native VLAN tagging: disabled
    // Allowed VLANs: 1-4095
    // Hybrid port configuration
    // -------------------------
    // Port Type: Unaware
    // Acceptable Frame Type: All
    // Ingress filter: Disabled
    // Egress tagging: None
    // Hybrid Native Mode VLAN: 10
    // Hybrid VLANs Enabled: 10,11
    //
    // The information of interest in each case is the "Hybrid Native Mode VLAN:" line.
    // Receivers will always show VLAN 10 here. Transmitters will show their VLAN, which will
    // be >= 11.
    // Cisco v1.3
    //
    // Vlan       Name            Ports                     Created by
    // ---- ----------------- --------------------------- --------------
    //  1           1         fa1/2/1-48,gi1/1/17-52,           D
    //                        gi1/2/1-4,te1/1/1-4,
    //                        fa2/2/1-48,gi2/1/17-52,
    //                        gi2/2/1-4,te2/1/1-4,
    //                        ...more entries...
    //                        gi8/2/1-4,te8/1/1-4,Po1-32
    //  2        CONTROL      gi1/1/1,gi2/1/1,gi3/1/1,          S
    //                        gi4/1/1,gi5/1/1,gi6/1/1,
    //                        gi7/1/1,gi8/1/1
    //  10  JAP_31x24_12345.. gi1/1/2-16,gi2/1/2-16,            S
    //                        gi5/1/2-26
    //  11    TX_1_gi1/1/2        gi1/1/2,gi2/1/11-16           S
    //  12    TX_2_gi1/1/3          gi1/1/3,gi1/1/9             S
    //  13    TX_3_gi1/1/4         gi1/1/4,gi1/1/10             S
    //  14    TX_4_gi1/1/5         gi1/1/5,gi1/1/11             S
    //  15    TX_5_gi1/1/6          gi1/1/6,gi2/1/5             S
    //  16    TX_6_gi1/1/7          gi1/1/7,gi2/1/8             S
    //  17    TX_7_gi5/1/2              gi5/1/2                 S
    //  18    TX_8_gi5/1/3              gi5/1/3                 S
    //  19    TX_9_gi5/1/4         gi1/1/12,gi5/1/4             S
    //  20    TX_10_gi1/1/5        gi1/1/13,gi5/1/5             S
    //  21    TX_11_gi1/1/6        gi1/1/14,gi5/1/6             S
    //  22    TX_12_gi1/1/7        gi1/1/15,gi5/1/7             S
    //  23    TX_13_gi1/1/8        gi1/1/16,gi5/1/8             S
    //  24    TX_14_gi1/1/9         gi2/1/2,gi5/1/9             S
    //  25    TX_15_gi1/1/10   gi2/1/3,gi2/1/10,gi5/1/10        S
    //  26    TX_16_gi1/1/11  gi1/1/8,gi2/1/4,gi2/1/9,          S
    //                        gi5/1/11
    //  27    TX_17_gi5/1/12       gi2/1/6,gi5/1/12             S
    //  27    TX_18_gi5/1/13       gi2/1/7,gi5/1/13             S
    //  27    TX_19_gi5/1/14           gi5/1/14                 S
    //  30    TX_20_gi5/1/15           gi5/1/15                 S
    //  31    TX_21_gi5/1/16           gi5/1/16                 S
    //  32    TX_22_gi5/1/17           gi5/1/17                 S
    //  33    TX_23_gi5/1/18           gi5/1/18                 S
    //  34    TX_24_gi5/1/19           gi5/1/19                 S
    //  35    TX_25_gi5/1/20           gi5/1/20                 S
    //  36    TX_26_gi5/1/21           gi5/1/21                 S
    //  37    TX_27_gi5/1/22           gi5/1/22                 S
    //  38    TX_28_gi5/1/23           gi5/1/23                 S
    //  39    TX_29_gi5/1/24           gi5/1/24                 S
    //  40    TX_30_gi5/1/25           gi5/1/25                 S
    //  41    TX_31_gi5/1/26           gi5/1/26                 S
    //
    // Cisco v1.4
    //
    // Vlan       Name           Tagged Ports      UnTagged Ports      Created by
    // ---- ----------------- ------------------ ------------------ ----------------
    //  1           1                            fa1/2/1-48,               V
    //                                           gi1/1/27-52,
    //                                           gi1/2/1-4,
    //                                           te1/1/1-4,
    //                                           fa2/2/1-48,
    //                                           gi2/1/27-52,
    //                                           gi2/2/1-4,
    //                                           ...more entries...
    //                                           gi8/1/49-52,
    //                                           gi8/2/1-4,
    //                                           te8/1/1-4,Pol1-32
    //  2       CONTROL                          gi1/1/1,                  S
    //                                           gi1/1/21-26,
    //                                           ...more entries...
    //  10  JAP_27x45x12345..                    gi1/1/2-20,               S
    //                                           gi2/1/2-13,
    //                                           gi3/1/2-11,
    //                                           gi4/1/2-7,
    //                                           gi5/1/2-26
    //  11    TX_1_gi1/1/2                       gi1/1/2-3,                S
    //                                           gi1/1/20,
    //                                           gi2/1/7-8,gi2/1/13
    //  12    TX_2_gi2/1/2                            gi2/1/2              S
    //  13    TX_3_gi2/1/3                            gi2/1/3              S
    //  14    TX_4_gi2/1/4                            gi2/1/4              S
    //  15    TX_5_gi2/1/5                            gi2/1/5              S
    //  16    TX_6_gi2/1/6                            gi2/1/6              S
    //  17    TX_7_gi3/1/2                       gi1/1/7,gi1/1/19,         S
    //                                           gi3/1/2,gi5/1/18
    //  18    TX_8_gi3/1/3                       gi1/1/8,gi3/1/3,          S
    //                                           gi5/1/17
    //  19    TX_9_gi3/1/4                       gi1/1/9,gi3/1/4,          S
    //                                           gi5/1/16
    //  20    TX_10_gi3/1/5                      gi1/1/10,gi3/1/5,         S
    //                                           gi5/1/14
    //  21    TX_11_gi3/1/6                      gi1/1/11,gi3/1/6,         S
    //                                           gi5/1/13
    //  22    TX_12_gi3/1/7                      gi1/1/12,gi3/1/7,         S
    //                                           gi5/1/12
    //  23    TX_13_gi3/1/8                      gi1/1/13,gi3/1/8,         S
    //                                           gi5/1/7,gi5/1/19
    //  24    TX_14_gi3/1/9                      gi1/1/4,gi1/1/15,         S
    //                                           gi3/1/9,gi5/1/8
    //  25    TX_15_gi3/1/10                     gi1/1/5,gi1/1/16,         S
    //                                           gi3/1/10,gi5/1/9
    //  26    TX_16_gi3/1/11                     gi1/1/6,gi1/1/17,         S
    //                                           gi3/1/11,gi5/1/10
    //  27    TX_17_gi4/1/2                           gi4/1/2              S
    //  28    TX_18_gi4/1/3                           gi4/1/3              S
    //  29    TX_19_gi4/1/4                           gi4/1/4              S
    //  30    TX_20_gi4/1/5                           gi4/1/5              S
    //  31    TX_21_gi4/1/6                      gi2/1/9-12,gi4/1/6        S
    //  32    TX_22_gi4/1/7                           gi4/1/7              S
    //  33    TX_23_gi5/1/2                      gi1/1/15,gi5/1/2,         S
    //                                           gi5/1/11,gi5/1/20,
    //                                           gi5/1/23
    //  34    TX_24_gi5/1/3                      gi1/1/18,gi5/1/3,         S
    //                                           gi5/1/15,gi5/1/21,
    //                                           gi5/1/24
    //  35    TX_25_gi5/1/4                      gi5/1/4,gi5/1/22,         S
    //                                           gi5/1/25
    //  36    TX_26_gi5/1/5                       gi5/1/5,gi5/1/26         S
    //  37    TX_27_gi6/1/5                           gi5/1/6              S
    queryVlans(tags) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            tags = [...tags, 'get.videoMatrixRoutes'];
            if (this.isQueryingVlans) {
                this.log.error(`vlan query requested while already in progress`);
                return this.vlans;
            }
            this.isQueryingVlans = true;
            const vlans = [];
            let vlanNumber = 1;
            let vlan;
            const columnStartIndices = [];
            const showRegExp = /#\s*show/;
            const vlanRegExp = /\s*(\d+)/;
            const nameRegExp = /\s*(\S+)/;
            const interfacesRegExp = (_b = (_a = this.api) === null || _a === void 0 ? void 0 : _a.interfacesRegExp) !== null && _b !== void 0 ? _b : /\s*(\S+)/;
            const id = this.socket.registerAsync(/^.+$/, (match) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                const line = match[0];
                if (showRegExp.exec(line))
                    return; // reject echo
                if (columnStartIndices.length === 0 && match[0].startsWith('--')) {
                    const re = /(-+\s*)/g;
                    for (let m = re.exec(line); m !== null; m = re.exec(line)) {
                        columnStartIndices.push(m.index);
                    }
                }
                else if (columnStartIndices.length > 0) {
                    const vlanMatch = vlanRegExp.exec(line.substring(columnStartIndices[(_b = (_a = this.api) === null || _a === void 0 ? void 0 : _a.vlanColumn) !== null && _b !== void 0 ? _b : 0]));
                    const nameMatch = nameRegExp.exec(line.substring(columnStartIndices[(_d = (_c = this.api) === null || _c === void 0 ? void 0 : _c.nameColumn) !== null && _d !== void 0 ? _d : 1]));
                    const interfacesMatch = interfacesRegExp.exec(line.substring(columnStartIndices[(_f = (_e = this.api) === null || _e === void 0 ? void 0 : _e.interfacesColumn) !== null && _f !== void 0 ? _f : 2]));
                    if (vlanMatch)
                        vlanNumber = parseInt(vlanMatch[1], 10);
                    if (vlanMatch) {
                        // First line of a vlan entry.
                        vlan = {
                            name: (_g = nameMatch === null || nameMatch === void 0 ? void 0 : nameMatch[1]) !== null && _g !== void 0 ? _g : `VLAN ${vlanNumber}`,
                            interfaces: this.parseInterfaces((_h = interfacesMatch === null || interfacesMatch === void 0 ? void 0 : interfacesMatch[1]) !== null && _h !== void 0 ? _h : ''),
                            number: vlanNumber,
                        };
                        vlans.push(vlan);
                    }
                    else {
                        // Following lines of a vlan entry.
                        if (vlan === undefined) {
                            this.log.error(`no previous vlan defined for: ${line}`);
                            return;
                        }
                        vlan.interfaces.push(...this.parseInterfaces((_j = interfacesMatch === null || interfacesMatch === void 0 ? void 0 : interfacesMatch[1]) !== null && _j !== void 0 ? _j : ''));
                    }
                }
            });
            try {
                yield this.socket.sendAsync('show vlan', tags);
            }
            catch (error) {
                this.isQueryingVlans = false;
                this.socket.unregisterAsync(id);
                throw error;
            }
            try {
                // Use this as a way to know when the "show vlan" output is complete. The show vlan
                // can take several seconds on a large system. We have seen it take ~4 seconds on the
                // 35x153 reference system that Just Add Power uses in-house.
                yield this.socket.send('show', /^% Incomplete command/i, { sendTimeoutMs: 6000 });
            }
            catch (error) {
                if (error.code !== 'sendTimeout') {
                    this.isQueryingVlans = false;
                    this.socket.unregisterAsync(id);
                    throw error;
                }
            }
            this.socket.unregisterAsync(id);
            this.isQueryingVlans = false;
            return vlans;
        });
    }
    updateVideoMatrixRoutes(vlans, receivers) {
        for (const receiver of receivers) {
            const transmitterVlan = findVlanByInterface(vlans, receiver);
            if (transmitterVlan === undefined) {
                this.log.error(`no route for receiver ${JSON.stringify(receiver)}`);
                continue;
            }
            const receiverCode = getReceiverCode(receiver);
            const transmitterCode = getTransmitterCode(transmitterVlan);
            this.state.videoMatrixRoutes.update(receiverCode, transmitterCode);
        }
    }
}
// static properties
JustAddPower.driverType = 'socketDriver';
JustAddPower.key = '-MW1DnbejiTxMr6KVBuy';
JustAddPower.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
JustAddPower.socketOptions = [
    Object.assign(Object.assign({}, JustAddPower.baseSocketOptions), { negotiateTelnet: true, port: 23 }),
    Object.assign(Object.assign({}, JustAddPower.baseSocketOptions), { port: 4999 }),
];
